import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/finance/balance',
    name: 'finance-balance',
    meta: { title: i18n.t('router.finance.balance_manage'), headType: 0, auth: true },
    component: () => import('@/views/apply/finance/balance.vue')
  },
  {
    path: '/admin/apply/finance/income',
    name: 'finance-income',
    meta: { title: i18n.t('router.finance.income_detail'), headType: 0, auth: true },
    component: () => import('@/views/apply/finance/income.vue')
  },
  {
    path: '/admin/apply/finance/withdraw',
    name: 'finance-withdraw',
    meta: { title: i18n.t('router.finance.withdraw_manage'), headType: 0, auth: true },
    component: () => import('@/views/apply/finance/withdraw.vue')
  },
  {
    path: '/admin/apply/finance/setting',
    name: 'finance-setting',
    meta: { title: i18n.t('router.finance.finance_setting'), headType: 0, auth: true },
    component: () => import('@/views/apply/finance/setting.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/finance.js